import {SlideshowArrow} from './slideshow-arrow';
import {SlideshowControlDot} from './slideshow-control-dot';

type Props = {
    selectedSlide: number;
    slideCount: number;
    onControlClick?: (arg1: number) => void;
    showArrows?: boolean;
    isCircular?: boolean;
};

export function SlideshowControls(props: Props) {
    const {selectedSlide, slideCount, onControlClick, showArrows, isCircular} = props;

    return (
        <div className='flex align-center'>
            {showArrows && onControlClick ? (
                <SlideshowArrow
                    direction='left'
                    selectedSlide={selectedSlide}
                    slideCount={slideCount}
                    onSlideChange={onControlClick}
                    isCircular={isCircular}
                />
            ) : undefined}
            {slideCount > 1 &&
                // @ts-expect-error
                [...Array(slideCount).keys()].map((slideNum) => {
                    let state = 'inactive';
                    if (selectedSlide === slideNum) {
                        state = 'active';
                    } else if (selectedSlide > slideNum) {
                        state = 'viewed';
                    }

                    return (
                        <SlideshowControlDot
                            key={slideNum}
                            // @ts-expect-error
                            state={state}
                            onDotClick={
                                onControlClick
                                    ? () => {
                                          onControlClick(slideNum);
                                      }
                                    : undefined
                            }
                        />
                    );
                })}
            {showArrows && onControlClick ? (
                <SlideshowArrow
                    direction='right'
                    selectedSlide={selectedSlide}
                    slideCount={slideCount}
                    onSlideChange={onControlClick}
                    isCircular={isCircular}
                />
            ) : undefined}
        </div>
    );
}
